import { patchApiGalaxyServer } from 'services';
import { ArchiveTeamPayload } from 'ProfileModule/services/archiveTeamApi';

export interface ScheduleArchiveTeamPayload extends ArchiveTeamPayload {
  // yyyy-mm-dd
  scheduledArchiveDate: string;
}

export const scheduleArchiveTeam = ({
  params,
  token,
  config = {},
}: BaseApiParams<ScheduleArchiveTeamPayload>) =>
  patchApiGalaxyServer(`/lookup/teams/scheduleArchive`, params, config, token);
